import LoginRedirect from './LoginRedirect'

export default LoginRedirect
